type WithDateRange = {
  from: string
  to: string | null
}

/**
 * Sorts practical (work) experiences by their end ("to") date, most recent
 * first. Entries without an end date are treated as ongoing and sorted to the
 * top. Falls back to the start ("from") date when end dates are equal.
 *
 * Mirrors sortEducationEntriesByLatestTo so both documents-builder sections
 * share the same ordering rule.
 */
export const sortPracticalExperiencesByLatestTo = <T extends WithDateRange>(
  experiences: readonly T[],
): T[] =>
  [...experiences].sort((a, b) => {
    if (a.to === b.to) return (b.from ?? '').localeCompare(a.from ?? '')
    if (!a.to) return -1
    if (!b.to) return 1
    return b.to.localeCompare(a.to)
  })
